import React, { useEffect, useState } from 'react'
import { Modal, ProgressBar, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { COLORS, SIZES } from '../../styles/theme'
import { toast } from 'react-toastify';
import next from '../../images/booth/next_arrow.png'
import prev from '../../images/booth/prev_arrow.png'
import FinishScreen from './FinishScreen';

const StyledKiosk = styled(Modal)`
  .modal-content {
    border: 2px solid #5A66A7;
    border-radius: 24px;
    margin-top: 10%;
  }
  .modal-content:before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 36px solid #5A66A7;
    border-right: 12px solid transparent;
    border-top: 16px solid #5A66A7;
    border-bottom: 28px solid transparent;
    left: 2px;
    bottom: -32px;
  }
  .modal-content:after {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 36px solid #fff;
    border-right: 12px solid transparent;
    border-top: 12px solid #fff;
    border-bottom: 28px solid transparent;
    left: 4px;
    bottom: -28px;
  }
  .modal-header {
    align-items: center;
    margin: 0 32px;
    padding: 16px 0;
    border-bottom: 2px solid #5A66A7;
    .quiz-title {
      width: 40%;
      font-weight: 600;
      font-size: 18px;
      color: #3A2D86;
      margin: 0;
    }
    .status {
      text-align: right;
      small {
        color: #305F72;
        font-weight: bold;
      }
    }
    .progress {
      background-color: #B6F7F2;
      border-radius: 10px;
      height: 8px;
    }
    .progress-bar {
      background-color: #26B4A9;
    }
    .stats {
      text-decoration: underline;
      color: #26B4A9;
      font-size: 14px;
      margin-left: 12px;
      cursor: pointer;
      font-weight: 400;
    }
  }
  .modal-body {
    padding: 16px 32px;
    .question-text {
      font-weight: 600;
      color: #3C3C3C;
    }
    .navigate {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: 25%;
      left: 85%;
      right: 4%;
      img {
        width: 47%;
        cursor: pointer;
      }
    }
  }
`
const ChoiceItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .check-bullet {
    margin-right: 8px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid #3A2D86;
    .bullet {
      height: 10px;
      border-radius: 50%;
      padding: 6px;
      background-color: ${(props) => props.selected ? '#26B4A9' :'white'};
    }
    .show-correct {
      background-color: red;
    }
  }
  .choice-text {
    color: #3C3C3C;
    font-size: 14px;
    margin: 4px 0;
  }
  ${SIZES.mobile} {
    align-items: flex-start;
    .check-bullet {
      margin-right: 12px;
      margin-top: 2px;
    }
    .choice-text {
      margin: 0;
      margin-bottom: 8px;
    }
  }
`

export default function KioskModal({ title, quiz, kioskOpen, setKioskOpen }) {
  const [currentLesson, setCurrentLesson] = useState(0)
  const [isFinishScreen, setIsFinishScreen] = useState(false)
  const [answer, setAnswer] = useState('')

  const lesson = quiz[currentLesson] || {question:"",choices:[{id:"",text:""}]}

  useEffect(() => {
    if (currentLesson === quiz.length) {
      setIsFinishScreen(true)
      // --- send data to backend pass answers
    }
  }, [currentLesson])

  const answerQuestion = (id) => {
    setAnswer(id)
  }

  const onClickBtn = (btn) => {
    if (btn === "next"){ 
      if(answer === ''){
        toast("Please select an answer.")
      }else{
        const payload = {
          quizId: quiz.id,
          answer: answer,
          // order: viewQuestion.order,
        }
        // dispatch(submitAnswer(payload))
        setCurrentLesson(currentLesson + 1)
      }
    }
    if (btn === "prev") setCurrentLesson(currentLesson - 1)
    setAnswer('')
  }

  

  return (
    <StyledKiosk
      show={kioskOpen}
      onHide={() => setKioskOpen(false)}
      size="lg"
      aria-labelledby="kiosk-modal"
    >
      {isFinishScreen ? <FinishScreen /> :
        (<>
          <Modal.Header>
            <p className="quiz-title">{title}</p>
            <div className="status" style={{width: '38%'}}>
              <ProgressBar variant="default" now={(currentLesson+1)/quiz.length * 100} />
            </div>
            <div className="status">
              <small>Question {currentLesson+1} out of {quiz.length}</small>
            </div>
          </Modal.Header>
          <Modal.Body>
            <p className="question-text">{lesson.question}</p>
            <Row noGutters>
              {
                lesson.choices.map((option)=>(
                  <Col md={6} key={option.id}>
                    <ChoiceItem
                      onClick={()=>answerQuestion(option.id)} 
                      selected={true}
                      selected={option.id === answer}
                      // selected={option.id === (lesson.answer !== null ? lesson.answer : answer)}
                    >
                      <div className="check-bullet">
                        <div className="bullet"></div>
                        {/* <div className={(lesson.answer !== null && choice.id === lesson.correct_answer && choice.id !== lesson.answer) ? "bullet show-correct" : "bullet"} ></div> */}
                      </div>
                      <p className="choice-text">{option.text}</p>
                      
                    </ChoiceItem>
                  </Col>
                ))
              }
            </Row>
            <div className="navigate">
              { currentLesson > 0 && <img id="prev-button" src={prev} alt="prev icon" onClick={()=>onClickBtn('prev')} />}
              { currentLesson !== quiz.length && <img id="next-button" src={next} alt="next icon" onClick={()=>onClickBtn('next')} />}
            </div>
          </Modal.Body>
        </>
        )}
    </StyledKiosk>
  )

}
